import { ValidatorFn, Validators } from "@angular/forms";
import { TransactionSumInterface } from "./transactionSum-interface";
import { ColumnDef } from "./column-definition";

/** Validators for fields */
const validators = new Map<string, ValidatorFn[]>([
    ["type", [
        Validators.required,
    ]],
    ["totalAmount", [
        Validators.required,
    ]],
]);

/**
 * TransactionSum class used to wrap transaction sum interface
 */
export class TransactionSum {
    /** Attribute fields */
    private _type: string;
    private _totalAmount: number;

    /** Validators for transaction forms */
    public static validators = validators;

    /**
     * Construct the transaction from an interface
     */
    constructor(intf: TransactionSumInterface) {
        this._type = intf.TXN_TYPE?.trim() || "";
        this._totalAmount = parseFloat(intf.TOTAL_AMOUNT) + 0;
    }

    /**
     * Determine if two transactions are equal
     * 
     * @param txn The other transactions to check
     * @returns True if transactions are equal
     */
    public equals(txn: TransactionSum): boolean {
        return txn.type === this.type &&
            txn.totalAmount === this.totalAmount;
    }

    /**
     * Return a copy of this transaction
     */
    public copyOf(): TransactionSum {
        return new TransactionSum(this.asInterface());
    }

    /**
     * Return the transaction as an interface
     */
    public asInterface(): TransactionSumInterface {
        const intf: TransactionSumInterface = {
            TXN_TYPE: this.type,
            TOTAL_AMOUNT: ""+this.totalAmount,
        };

        return intf;
    }

    /**
     * Return the transaction as a string representation, used for filtering/searching
     * 
     * We use a unicode full block as a delimeter, so the only string matches that
     * return are from our fields (unless the user is typing the unicode full block
     * character like a maniac)
     */
    public toString(defs: ColumnDef[]): string {
        let str = "";
        for (let col of defs) {
            if (col.toStringTransform != undefined) {
                str += col.toStringTransform((this as any)[col.field]) + "█";
            } else {
                str += (this as any)[col.field];
            }
        }

        return str.toLowerCase();
    }

    /** Setters */
    set type(type: string) {
        this._type = type;
    }

    set totalAmount(totalAmount: number) {
        this._totalAmount = totalAmount;
    }

    /** Getters */
    get type(): string {
        return this._type;
    }

    get totalAmount(): number {
        return this._totalAmount;
    }
}